import { IconChevronDown, IconChevronUp, IconSelector } from "@tabler/icons-react";
import {ThProps} from "../../../types/types";
import { Group, Table, UnstyledButton, Text, Center } from "@mantine/core";
import classes from "../TableSort.module.css";

export default function TableHeader({ children, reversed, sorted, onSort }: ThProps) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;
  return (
    <Table.Th className={classes.th}>
      <UnstyledButton onClick={onSort} className={classes.control}>
        <Group justify="space-between">
          <Text fw={500} fz="sm">
            {children}
          </Text>
          <Center className={classes.icon}>
            <Icon size={16} stroke={1.5} />
          </Center>
        </Group>
      </UnstyledButton>
    </Table.Th>
  );
}